/* eslint-disable no-param-reassign */
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Alert, Button, Checkbox, Drawer, Dropdown, notification, Popconfirm, Popover, Table,
} from 'antd';
import { CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import { QUANTITY } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import OtherDepartmentsStock from '@Components/Inventory/ManageProducts/ProductsList/OtherDepartmentsStock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faRotateRight, faScissors } from '@fortawesome/free-solid-svg-icons';
import ProductCategoryLabel from '../../../../../../Common/ProductCategoryLabel';
import CustomFieldHelpers from '../../../../../../../helpers/CustomFieldHelpers';
import CustomDocumentColumns from '@Components/Common/CustomDocumentColumns';
import helpers from '../../../../../../../apis/helpers';
import './style.scss';
/**
 *
 */
class PurchaseRequestLines extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleRemoveRMLines(selectedRowKeys) {
    const {
      copyMoLines,
      updateData,
      updateOptionsForProductCategoryFilter,
      updateSelectedProductCategory,
      moLines,
    } = this.props;

    const copyData = JSON.parse(JSON.stringify(copyMoLines));

    // Retrieve previously removed keys from sessionStorage (this will reset on page refresh or close)
    const storedRemovedKeys = JSON.parse(sessionStorage.getItem('removed_line_keys_mo_to_pr')) || [];

    // Merge current and previously removed keys
    const updatedRemovedKeys = [...new Set([...storedRemovedKeys, ...selectedRowKeys])];

    // Store updated removed keys in sessionStorage
    sessionStorage.setItem('removed_line_keys_mo_to_pr', JSON.stringify(updatedRemovedKeys));
    // Filter out the removed lines from the data
    const filteredData = copyData?.filter((item) => !updatedRemovedKeys?.includes(item.key));
    // Filter options for product categories based on the updated data
    const newFilterOptions = [
      ...new Map(
        filteredData
          ?.filter(
            (item) => item?.tenant_product_info?.product_category_id // Ensure `product_category_id` exists
              && item?.tenant_product_info?.category_path?.length > 0, // Ensure `category_path` is not empty
          )
          .map((item) => [
            item?.tenant_product_info?.product_category_id, // Use `id` as the key to ensure uniqueness
            {
              id: item?.tenant_product_info?.product_category_id,
              name: item?.tenant_product_info?.category_path[
                item?.tenant_product_info?.category_path.length - 1
              ],
            },
          ]),
      ).values(),
    ];

    // Show notifications for removed lines
    const removedLines = copyData?.filter((item) => selectedRowKeys?.includes(item.key));
    removedLines?.forEach((item) => {
      const productName = item?.tenant_product_info?.alias_name || '';
      const skuCode = item?.tenant_product_info?.internal_sku_code || '';
      notification.open({
        type: 'warning',
        message: `The product "${skuCode}: ${productName}" has been removed.`,
        placement: 'top',
        duration: 5,
      });
    });

    // Update data and options
    updateData(filteredData);
    updateOptionsForProductCategoryFilter(newFilterOptions);
    updateSelectedProductCategory([]);
    this.setState({ selectedRowKeys: [] });
  }

  getColumns() {
    const {
      cfPurchaseRequestLine, visibleColumns, customLineInputChange, isCarryForward, moLines, soLines, formSubmitted, user,
    } = this.props;
    const moListColumns = [
      {
        title: 'PRODUCT',
        fixed: 'left',
        render: (text, record) => {
          const { updateData, moLines } = this.props;
          return (
            <div className="pr-table__product-name" style={{ width: '240px' }}>
              <Link to={`/inventory/product/view/${record?.tenant_product_info?.product_sku_id}`}>
                {`#${record?.tenant_product_info?.internal_sku_code}`}
              </Link>
              <div>
                {`${record?.tenant_product_info?.ref_product_code ? `${record?.tenant_product_info?.ref_product_code} - ` : ''}${record?.tenant_product_info?.product_sku_name}`}

              </div>

              {record?.tenant_product_info?.category_path?.length > 0 && (
                <ProductCategoryLabel
                  categoryPath={record?.tenant_product_info?.category_path}
                  categoryName={record?.tenant_product_info?.category_path?.at(-1)}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
              )}
              <textarea
                style={{
                  width: '215px',
                }}
                value={record?.remarks}
                onChange={(e) => {
                  const copyData = JSON.parse(JSON.stringify(moLines));
                  const updatedLines = copyData.map((item) => {
                    if (item.key === record.key) {
                      item.remarks = e.target.value;
                    }
                    return item;
                  });
                  updateData(updatedLines);
                }}
                className="so-table__remarks"
                placeholder="add description here.."
              />
            </div>
          );
        },
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'FG/SFG',
        render: (text, record) => {
          const parentProductInfo = record?.parent_mo_line_id ? this.props?.copyMoLines?.find((item) => item.mo_line_id === record?.parent_mo_line_id)?.tenant_product_info : this.props?.selectedMO?.mo_finished_goods?.find((item) => item.tenant_product_id === record?.fg_tenant_product_id)?.tenant_product_info;
          return (
            <div style={{ width: '140px' }}>
              <Link to={`/inventory/product/view/${parentProductInfo?.product_sku_id}`} target='_blank'>
                {`#${parentProductInfo?.internal_sku_code}`}
              </Link>
              <div>
                <div>
                  {`${parentProductInfo?.ref_product_code ? `${parentProductInfo?.ref_product_code} - ` : ''}${parentProductInfo?.product_sku_name}`}
                </div>
                <div className="view-mo-rm-qty" style={{ backgroundColor: record?.parent_mo_line_id ? 'rgba(199,199,199,0.5)' : 'rgba(50,180,13,0.2)' }}>
                  {record?.parent_mo_line_id ? 'SFG' : 'FG'}
                </div>
              </div>
            </div>
          );
        },
        visible: visibleColumns?.FG_SFG?.visible,
      },
      {
        title: 'AVAILABLE STOCK',
        render: (text, record) => {
          const { selectedMO } = this.props;
          const filteredDepartmentsStock = record?.tenant_product_info?.department_quantities?.filter((item) => item?.tenant_department_id !== selectedMO?.tenant_department_id);
          const totalStockInOtherDepartments = filteredDepartmentsStock?.map((dept) => dept?.quantity).reduce((acc, cur) => acc + cur, 0);
          const hoverContent = (
            <div>
              {filteredDepartmentsStock?.map((dept) => (
                <div key={dept.department_id} className="other-uom-stock">
                  <H3Text text={dept?.alias_name} />
                  <H3Text
                    text={`${QUANTITY(dept?.quantity)} ${record?.uom_info?.uqc?.toProperCase()}`}
                    className="tenant-inventory-slider__dept-qty"
                  />
                </div>
              ))}
            </div>
          );
          return (
            <div>
              {`${QUANTITY(record?.available_quantity, record?.uom_info?.precision) || '0'} ${record?.uom_info?.uqc?.toProperCase()}` || ''}
              {totalStockInOtherDepartments > 0 && (
                <Popover
                  placement="bottom"
                  title="Stocks in other locations"
                  content={hoverContent}
                  trigger="hover"
                >
                  <div
                    className="table-subscript"
                    style={{
                      color: 'rgb(109 107 106)',
                    }}
                  >
                    {`+${QUANTITY(totalStockInOtherDepartments, record?.uom_info?.precision)}  ${record?.uom_info?.uqc?.toProperCase() || ''} in other locations`}
                    <InfoCircleOutlined style={{
                      color: 'rgb(45, 124, 246)',
                      margin: '2px',
                    }}
                    />
                  </div>
                </Popover>
              )}
            </div>
          );
        },
        visible: visibleColumns?.AVAILABLE_STOCK?.visible,
      },
      {
        title: 'BOM QUANTITY',
        render: (text, record) => (
          <div>
            {`${QUANTITY(record?.bomQuantity, record?.uom_info?.precision) || '0'} ${record?.uom_info?.uqc?.toProperCase()}` || ''}
          </div>
        ),
        visible: visibleColumns?.BOM_QTY?.visible,
      },
      {
        title: 'SHORT QUANTITY',
        render: (text, record) => (
          <div>
            {`${QUANTITY(record?.shortfall, record?.uom_info?.precision) || '0'} ${record?.uom_info?.uqc?.toProperCase()}` || ''}
          </div>
        ),
        visible: visibleColumns?.SHORT_QTY?.visible,
      },
      {
        title: 'QUANTITY',
        dataIndex: 'quantity',
        width: '150px',
        render: (text, record) => {
          const { formSubmitted, updateData, moLines } = this.props;
          return (
            <div>
              <H3FormInput
                value={record.quantity}
                type="number"
                containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) <= 0) ? 'show-error' : ''}`}
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(e) => {
                  CustomFieldHelpers.updateCustomColumnValue(Number(e.target.value || 0), record.lineCustomFields?.find((i) => i?.fieldName === 'Quantity'), record.lineCustomFields, (value) => customLineInputChange(value, record?.key));
                }}
                disabled={!user?.tenant_info?.permission?.editable_material_request_qty_from_mo}
              />
            </div>
          );
        },
        visible: visibleColumns?.QUANTITY?.visible,
      },
      {
        title: 'UNIT',
        width: '120px',
        render: (text, record) => (
          <div>
            {record?.uom_info?.uqc?.toProperCase()}
          </div>
        ),
        visible: visibleColumns?.UNIT?.visible,
      },
      {
        title: '',
        fixed: 'right',
        render: (text, record) => {
          const { handleDelete } = this.props;
          return (
            <Fragment>
              <Popconfirm title="Confirm remove product?" onConfirm={() => handleDelete(record.key)} placement='topRight'>
                <div className="update-pr__delete-line-button">
                  <CloseOutlined />
                </div>
              </Popconfirm>
            </Fragment>
          );
        },
        width: '40px',
        visible: true,
      },
    ];
    const soListColumns = [
      {
        title: 'PRODUCT',
        fixed: 'left',
        render: (text, record) => {
          const { updateData, soLines } = this.props;
          return (
            <div className="pr-table__product-name" style={{ width: '240px' }}>
              <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`}>
                {`#${record?.product_sku_info?.internal_sku_code}`}
              </Link>
              <div>
                {`${record?.product_sku_info?.ref_product_code ? `${record?.product_sku_info?.ref_product_code} - ` : ''}${record?.product_sku_info?.product_sku_name}`}
              </div>
              <textarea
                style={{
                  width: '215px',
                }}
                value={record?.remarks}
                onChange={(e) => {
                  const copyData = JSON.parse(JSON.stringify(soLines));
                  const updatedLines = copyData.map((item) => {
                    if (item.key === record.key) {
                      item.remarks = e.target.value;
                    }
                    return item;
                  });
                  updateData(updatedLines);
                }}
                className="so-table__remarks"
                placeholder="add description here.."
              />
            </div>
          );
        },
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'AVAILABLE STOCK',
        render: (text, record) => (
          <div>
            {`${QUANTITY(record?.available_quantity, record?.uom_info?.precision) || '0'} ${record?.uom_info?.[0]?.uqc?.toProperCase()}` || ''}
          </div>
        ),
        visible: visibleColumns?.AVAILABLE_STOCK?.visible,
      },
      {
        title: 'SHORT QUANTITY',
        render: (text, record) => (
          <div>
            {`${QUANTITY(record?.shortfall, record?.uom_info?.precision) || '0'} ${record?.uom_info?.[0]?.uqc?.toProperCase()}` || ''}
          </div>
        ),
        visible: visibleColumns?.SHORT_QTY?.visible,
      },
      {
        title: 'QUANTITY',
        dataIndex: 'quantity',
        width: '150px',
        render: (text, record) => {
          const {
            formSubmitted, updateData, soLines, user,
          } = this.props;
          const allowExcessQtyForSoToPr = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.allow_excess_quantity_for_so_to_pr;

          const QtyValidation = (!Number(record.pr_quantity)) || ((Number(record.pr_quantity) > Number(record.shortfall)) && !allowExcessQtyForSoToPr);
          return (
            <div>
              <H3FormInput
                value={record.pr_quantity}
                type="number"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                onChange={(e) => {
                  CustomFieldHelpers.updateCustomColumnValue(Number(e.target.value || 0), record.lineCustomFields?.find((i) => i?.fieldName === 'Quantity'), record.lineCustomFields, (value) => customLineInputChange(value, record?.key));
                }}
              />
              {(Number(record.pr_quantity) > Number(record.shortfall)) && !allowExcessQtyForSoToPr && (
                <div className="input-error">
                  *Excess Quantity Not Allowed
                </div>
              )}
            </div>
          );
        },
        visible: visibleColumns?.QUANTITY?.visible,
      },
      {
        title: 'UNIT',
        width: '120px',
        render: (text, record) => (
          <div>
            {record?.uom_info?.[0]?.uqc?.toProperCase()}
          </div>
        ),
        visible: visibleColumns?.UNIT?.visible,
      },
      {
        title: '',
        fixed: 'right',
        render: (text, record) => {
          const { handleDelete } = this.props;
          return (
            <Fragment>
              <Popconfirm title="Confirm remove product?" onConfirm={() => handleDelete(record.key)}>
                <div className="update-pr__delete-line-button">
                  <CloseOutlined />
                </div>
              </Popconfirm>
            </Fragment>
          );
        },
        width: '40px',
        visible: true,
      },
    ];

    if (cfPurchaseRequestLine?.length) {
      if (moLines?.length) {
        moListColumns?.splice(4, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfPurchaseRequestLine, visibleColumns, customLineInputChange, formSubmitted, '', '', '', '', '', '', '', isCarryForward));
        return moListColumns?.filter((item) => { return (item?.visible); });
      } else {
        soListColumns?.splice(3, 0, ...CustomFieldHelpers.renderCustomLineColumns(false, cfPurchaseRequestLine, visibleColumns, customLineInputChange, formSubmitted, '', '', '', '', '', '', '', isCarryForward));
        return soListColumns?.filter((item) => { return (item?.visible); });
      }
    }
    return [];
  }

  // getDataSource = (data) => (data?.length ? JSON.parse(JSON.stringify(data)) : [])

  getDataSource = (data) => {
    if (!data?.length) return [];
    const copyData = structuredClone(data);
    const sortedData = helpers.sortByParameter({
      data: copyData,
      parameter: this.props?.selectedMO ? 'tenant_product_info.internal_sku_code' : 'product_sku_info.internal_sku_code',
    });

    return [
      ...sortedData.filter((item) => item?.product_sku_id),
      ...sortedData.filter((item) => !item?.product_sku_id),
    ];
  };

  handleResetRMLines = () => {
    const {
      copyMoLines, updateData, updateOptionsForProductCategoryFilter, updateSelectedProductCategory,
    } = this.props;

    const copyData = JSON.parse(JSON.stringify(copyMoLines));
    const newFilterOptions = [
      ...new Map(
        copyData
          ?.filter(
            (item) => item?.tenant_product_info?.product_category_id // Ensure `product_category_id` exists
              && item?.tenant_product_info?.category_path?.length > 0, // Ensure `category_path` is not empty
          )
          .map((item) => [
            item?.tenant_product_info?.product_category_id, // Use `id` as the key to ensure uniqueness
            {
              id: item?.tenant_product_info?.product_category_id,
              name: item?.tenant_product_info?.category_path[
                item?.tenant_product_info?.category_path.length - 1
              ],
            },
          ]),
      ).values(),
    ];

    sessionStorage.setItem('removed_line_keys_mo_to_pr', JSON.stringify([]));
    this.setState({ selectedRowKeys: [] });
    updateData(copyData);
    updateOptionsForProductCategoryFilter(newFilterOptions || []);
    updateSelectedProductCategory([]);
  };

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      getMOByIdLoading, loading, moLines, soLines, setShowFulfilledLines, showFulfilledLines, setIsUserReady, isUserReady, user, prFromMoScreen, updateData, formSubmitted, cfPurchaseRequestLine, visibleColumns, setVisibleColumns, updateOptionsForProductCategoryFilter, copyMoLines, updateSelectedProductCategory,
    } = this.props;
    const {
      moListColumns, soListColumns, showOtherDepartmentStock, selectedProductSkuId, tenantId, useBOMQtyForShortfall, selectedRowKeys, selectedRows, removed_line_keys_mo_to_pr,
    } = this.state;
    const allowExcessQtyForSoToPr = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.allow_excess_quantity_for_so_to_pr;

    return (
      <div className="pr-table__wrapper">
        <Drawer
          placement="right"
          onClose={() => this.setState({ showOtherDepartmentStock: false })}
          open={showOtherDepartmentStock}
          width="360px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '310px' }}>
              <H3Text text="Stock in Other Departments" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showOtherDepartmentStock: false })} />
            </div>
          </div>
          <OtherDepartmentsStock selectedProductSkuId={selectedProductSkuId} tenantId={tenantId} />
        </Drawer>
        {copyMoLines?.length > 0 ? (
          <Table
            bordered
            title={() => (
              <div className="create-pr-title__wrapper">
                {`Raw Material (${moLines?.length || 0})`}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                  }}
                >
                  <Dropdown
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    overlay={(
                      <div className="line_actions-wrapper">
                        <div className="line_actions" onClick={this.handleResetRMLines}>
                          <FontAwesomeIcon icon={faRotateRight} style={{ marginTop: '6px' }} size="sm" />
                          &nbsp; Reset RM Lines
                        </div>

                        {selectedRowKeys?.length > 0 && (
                          <div className="line_actions" onClick={() => this.handleRemoveRMLines(selectedRowKeys)}>
                            <FontAwesomeIcon icon={faScissors} style={{ marginTop: '6px' }} size="sm" />
                            &nbsp; Remove Raw Materials
                          </div>
                        )}
                      </div>
                    )}
                    placement="topRight"
                    trigger={['click']}
                  >
                    <div style={{ marginRight: '5px' }} className="custom-doc-columns__wrapper">
                      Actions
                    </div>
                  </Dropdown>
                  {prFromMoScreen && (
                    <div className="create-pr-title-left">
                      <Checkbox
                        checked={useBOMQtyForShortfall}
                        onChange={(e) => {
                          const copyData = JSON.parse(JSON.stringify(moLines));
                          const updatedLines = copyData.map((item) => {
                            if (e.target.checked) {
                              item.quantity = Number(item.bomQuantity);
                            } else {
                              item.quantity = Number(item.shortfall);
                            }
                            return item;
                          });
                          updateData(updatedLines);
                          this.setState({ useBOMQtyForShortfall: e.target.checked });
                        }}
                        disabled={loading}
                      />
                      <div style={{ marginLeft: '5px' }}>Use BoM quantity for raising MR</div>
                    </div>
                  )}
                  <CustomDocumentColumns
                    visibleColumns={visibleColumns || []}
                    setVisibleColumns={(dt) => setVisibleColumns(dt)}
                    customColumns={cfPurchaseRequestLine || []}
                    data={moLines}
                    updateData={(updatedData) => updateData(updatedData)}
                  />
                </div>
              </div>
            )}
            showHeader
            size="small"
            scroll={{ x: 'max-content' }}
            columns={this.getColumns()}
            dataSource={this.getDataSource(moLines) || []}
            loading={loading || getMOByIdLoading}
            pagination={false}
            rowSelection={(window.screen.width > 325) ? {
              onChange: (rowKeys, rows) => {
                this.setState({ selectedRowKeys: rowKeys, selectedRows: rows });
              },
              selectedRowKeys,
            } : false}
          />
        ) : (
          <Table
            bordered
            title={() => (
              <div className='pr-table__header' style={{ display: 'flex', justifyContent: 'space-between' }}>
                <H3Text text={`Material Request Lines (${soLines?.length || '0'})`} className="form__input-row__label" />
                <div style={{ display: 'flex' }}>
                  <div style={{ display: 'flex', marginRight: '10px', marginTop: '2px', }}>
                    <Checkbox
                      checked={showFulfilledLines}
                      onChange={() => {
                        setShowFulfilledLines(!showFulfilledLines);
                        setIsUserReady(!isUserReady);
                      }}
                      disabled={loading || !allowExcessQtyForSoToPr}
                    />
                    <div style={{ marginLeft: '5px', marginTop: '2px' }}>Show items with short fall only</div>
                  </div>
                  {!showFulfilledLines && <CustomDocumentColumns
                    visibleColumns={visibleColumns || []}
                    setVisibleColumns={(dt) => setVisibleColumns(dt)}
                    customColumns={cfPurchaseRequestLine || []}
                    data={soLines}
                    updateData={(updatedData) => updateData(updatedData)}
                  />}
                </div>
              </div>
            )}
            showHeader
            size="small"
            scroll={{ x: 'max-content' }}
            columns={this.getColumns()}
            dataSource={this.getDataSource(soLines) || []}
            loading={loading || getMOByIdLoading}
            pagination={false}
          />
        )}
        {
          showFulfilledLines && !soLines?.length && <Alert type="info" style={{ marginTop: '15px' }} message="There are no items with shortfall. Please disable the shortfall checkbox if you still want to create a material request." showIcon />
        }
      </div>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, MOReducers,
}) => ({
  user: UserReducers.user,
  getMOByIdLoading: MOReducers.getMOByIdLoading,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

PurchaseRequestLines.propTypes = {
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  formSubmitted: PropTypes.bool,
  getMOByIdLoading: PropTypes.any,
  moLines: PropTypes.any,
  soLines: PropTypes.any,
  loading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseRequestLines));
